const Twitter = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0626 5.13281C22.2469 5.49375 21.3751 5.7375 20.4563 5.85C21.3938 5.2875 22.1157 4.39687 22.4532 3.3375C21.5766 3.85781 20.6063 4.2375 19.5704 4.43906C18.7407 3.55312 17.5594 3 16.2563 3C13.7485 3 11.7188 5.03437 11.7188 7.54219C11.7188 7.89844 11.7563 8.24531 11.836 8.57812C8.06257 8.39062 4.7157 6.58125 2.47976 3.82969C2.0907 4.5 1.8657 5.28281 1.8657 6.1125C1.8657 7.6875 2.67195 9.07969 3.8907 9.89531C3.1407 9.87656 2.43757 9.67031 1.8282 9.32812V9.38437C1.8282 11.5875 3.39382 13.4203 5.47039 13.8375C5.0907 13.9406 4.68757 13.9969 4.27507 13.9969C3.98445 13.9969 3.69851 13.9687 3.42195 13.9125C3.99851 15.7172 5.67664 17.0297 7.66414 17.0672C6.11257 18.2859 4.1532 19.0125 2.02507 19.0125C1.65945 19.0125 1.29851 18.9891 0.942261 18.9469C2.94382 20.25 5.32976 21 7.88914 21C16.2469 21 20.8126 14.0766 20.8126 8.07187C20.8126 7.875 20.8079 7.67812 20.7985 7.48594C21.6844 6.84375 22.4532 6.04688 23.0626 5.13281Z"
      fill="white"
    />
  </svg>
);

export default Twitter;
